module.exports = __webpack_public_path__ + "media/images/barcode_invalid-b42b863931818eb3cd3e0fe766ea1f4a.gif";